import { React, useEffect, useState } from "react";
import * as api from "../api/api";
import ListGroup from "react-bootstrap/ListGroup";
import noData from "../../src/images/noData.svg";
import Badge from "react-bootstrap/Badge";
import { IoArrowForwardCircleOutline } from "react-icons/io5";
import { MdKeyboardArrowRight } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import Loading from "../Components/Loading";
import { Button } from "react-bootstrap";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";

const ChooseTenant = (redirectUrl) => {
  let navigate = useNavigate();
  const { instance } = useMsal();
  const [availableTenants, setAvailableTenants] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const authenticated = useIsAuthenticated();

  const handleChoosingTenant = (tenant) => {
    console.log(tenant);
    sessionStorage.setItem("userTenant", JSON.stringify(tenant));
    navigate(redirectUrl);
  };
  useEffect(() => {
    // TODO : get user ID from user not fixed user ID
    setLoading(true);
    api
      .getUserTenants()
      .then((response) => {
        console.log(response.data.object, response.data.object);
        if (response.data.object == null) {
          setLoading(false);
        }
        setAvailableTenants(
          response.data.object
            ?.filter((tenant) => tenant.isActive)
            .map((tenant) => {
              return tenant;
            })
        );
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  }, [authenticated]);
  return (
    <div
      className="d-flex flex-column align-items-center"
      style={{ height: "100vh", backgroundColor: "var(--secondary-color)" }}
    >
      <h2 style={{ marginBottom: "2em", marginTop: "3em" }}>
        Please choose a tenant to continue{" "}
      </h2>
      {(isLoading || !authenticated) && <Loading />}
      {availableTenants?.length >= 1 ? (
        <ListGroup
          as="ol"
          numbered
          style={{ width: "35%", height: "60%", overflow: "auto" }}
        >
          {availableTenants.map((tenant) => {
            return (
              <ListGroup.Item
                style={{ cursor: "pointer" }}
                action
                as="li"
                key={tenant.tenantId}
                onClick={() => handleChoosingTenant(tenant)}
                className="d-flex justify-content-between align-items-start"
              >
                <div className="ms-2 me-auto">
                  <div className="fw-bold">{tenant.name}</div>
                </div>
                <MdKeyboardArrowRight size={"2em"} />
              </ListGroup.Item>
            );
          })}
        </ListGroup>
      ) : (
        <div
          className="d-flex flex-column align-items-center"
          style={{ overflow: "hidden" }}
        >
          <img width="100%" height="50%" src={noData} alt="start adding" />
          <h6 className="mt-4">No active tenants found for this user ! </h6>
          <Button
            variant="primary"
            onClick={() => {
              window !== window.parent
                ? instance
                    .logoutPopup()
                    .then(() => {
                      console.log("logged out");
                      sessionStorage.removeItem("userTenant");
                      //sessionStorage.setItem("loginPopupShown", false);
                      //navigate("/postLogout");
                    })
                    .catch((err) => {
                      console.log("failed to logout", err);
                    })
                : instance
                    .logoutRedirect()
                    .then(() => {
                      console.log("logged out");
                      sessionStorage.removeItem("userTenant");
                      //sessionStorage.setItem("loginPopupShown", false);
                      // navigate("/postLogout");
                    })
                    .catch((err) => {
                      console.log("failed to logout", err);
                    });
            }}
          >
            Log out
          </Button>
        </div>
      )}
    </div>
  );
};

export default ChooseTenant;
